export default __webpack_public_path__ + "badge_virtu_slashes.png";